export default __webpack_public_path__ + "static/achievement-2-02bc1d95c62b61b356f9b3b5d32faf3d.webp";